// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605111033/js/" + chunkId + "." + {"44":"ff8660bf","225":"d77d5289","481":"2ee1e8e7","486":"81fd8ddd","770":"fed70056"}[chunkId] + ".0.7577157628091753.chunk.js";
};